import React from 'react'

const Exercise = () => {
  return (
    <div>Exercise</div>
  )
}

export default Exercise